import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, useIntl } from "react-intl";
import "./DashboardModal.css";
import { SizeGuideServices } from "../../../services";
import { IBaseItem } from "../types";

function DashboardModal(props: any) {
    const [SizeGuides, setSizeGuides] = useState<any[]>();
    const [isLoadingSizeGuides, setIsLoadingSizeGuides] = useState(false);
  const intl = useIntl();

  const [show, setShow] = useState(false);
  //const [selectedOption, setSelectedOption] = useState(
  //  intl.formatMessage({
  //    id: "ready-size-example-guide",
  //    defaultMessage: "Guia Ejemplo",
  //  })
  //  );

    const [selectedOption, setSelectedOption] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    useEffect(() => {

        (async () => {
            try {
                setIsLoadingSizeGuides(true);

                const getSizeGuides = await SizeGuideServices.GetSizesGuides();

                if (getSizeGuides && getSizeGuides.Status === 200) {
                    setSizeGuides(getSizeGuides.Content);
                } else {
                    setSizeGuides([]);
                }

                setIsLoadingSizeGuides(false);
            } catch (error) {
                console.log(error);

                setIsLoadingSizeGuides(false);
            }
        })();

    }, [setSizeGuides])

  const handleOptionSelect = (event: any) => {
      setSelectedOption(event.target.value);

      if (props.SuscribedChange) props.SuscribedChange(event.target.value);

      setShow(false);
  };

  return (
    <>
      <div>
        <Button className="dashboard-modal-button" onClick={handleShow}>
          <FontAwesomeIcon
            className="dashboard-descarga-icon"
            icon={faArrowDown}
          />
                  {((props.DefaultData) ?
                      SizeGuides?.find((element: IBaseItem, index: number) => {
                          return (element.Id === props.DefaultData);
                      }).Name : "")}
        </Button>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="false"
          keyboard={false}
          centered
          className="dashboard-main-modal"
        >
          <Modal.Header closeButton className="dashboard-modal-closebutton">
            <Modal.Title className="dashboard-modal-title">
              <FormattedMessage id="dashboard-modal-guide-select" />
            </Modal.Title>
          </Modal.Header>
          <div className="dashboard-modal-select">
            <Form.Select
                          className="dashboard-modal-select"
                          aria-label="Default select example"
                          onChange={handleOptionSelect}
                          //value={selectedOption}
                          defaultValue={((props.DefaultData) ? props.DefaultData : undefined) }
            >
              {/*<option value="Guia Ejemplo"> Option</option>*/}
              {/*<option value="INFERIOR_NUM_01">Option 1</option>*/}
              {/*<option value="SUPERIOR_NUM_01">Option 2</option>*/}
                          {/*<option value="INFERIOR_NUM_02">Option 3</option>*/}
                          {SizeGuides?.map((element: IBaseItem, index: number) => {
                              return (
                                  <option
                                      value={element.Id}
                                      key={`select-sizeguide-${element.Id}`}
                                      selected={(((props.DefaultData) && (props.DefaultData === element.Id)) ? true : false)}
                                  >
                                      {element.Name}
                                  </option>
                              );
                          })}
            </Form.Select>
          </div>
          <Modal.Body>
            <div>
              {/*<Row>*/}
              {/*  <Col className="dashboard-modal-bold">*/}
              {/*    <FormattedMessage id="ready-size-clothing-type" />{" "}*/}
              {/*    <span className="dashboard-modal-fino">*/}
              {/*      {" "}*/}
              {/*      <FormattedMessage id="ready-size-superior" />*/}
              {/*    </span>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              {/*<Row>*/}
              {/*  <Col className="dashboard-modal-bold">*/}
              {/*    <FormattedMessage id="ready-size-gender" />{" "}*/}
              {/*    <span className="dashboard-modal-fino">*/}
              {/*      <FormattedMessage id="ready-size-female" />*/}
              {/*    </span>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default DashboardModal;
